var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSdhLogoMobile = function SvgSdhLogoMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 52 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#261F56",
    fillRule: "evenodd",
    d: "M8.331 3.647c-1.91 0-3.387 1.074-3.387 2.546 0 2.125 2.233 2.934 4.757 3.85 3.283 1.189 7.06 2.558 7.066 7.231 0 3.908-3.577 6.726-8.296 6.726-4.07 0-7.3-2.261-8.471-5.976l3.555-1.355c.719 2.142 2.577 3.652 4.81 3.652 2.389 0 4.117-1.173 4.117-2.846 0-2.312-2.34-3.141-4.934-4.061-3.23-1.145-6.854-2.43-6.854-6.886C.694 2.77 4.164 0 8.53 0c3.48 0 6.26 2.12 7.495 5.297l-3.449 1.286c-.926-2.075-2.154-2.936-4.245-2.936Zm39.02 5.995V.402H51.6V23.67h-4.25V13.526h-9.772V23.67h-4.25V13.56h-14.45V9.676h14.45V.402h4.25v9.24h9.772Z",
    clipRule: "evenodd"
  })));
};
export default SvgSdhLogoMobile;